import { c as _c } from "react/compiler-runtime";
import IdentitySearch, { IdentitySearchSize } from "../input/identity/IdentitySearch";
import SelectGroupModalSearchName from "./SelectGroupModalSearchName";
export default function SelectGroupModalSearch(t0) {
  const $ = _c(9);
  const {
    groupName,
    groupUser,
    onUserSelect,
    onFilterNameSearch
  } = t0;
  let t1;
  if ($[0] !== groupUser || $[1] !== onUserSelect) {
    t1 = <IdentitySearch size={IdentitySearchSize.SM} identity={groupUser} setIdentity={onUserSelect} />;
    $[0] = groupUser;
    $[1] = onUserSelect;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== groupName || $[4] !== onFilterNameSearch) {
    t2 = <SelectGroupModalSearchName filterName={groupName} setFilterName={onFilterNameSearch} />;
    $[3] = groupName;
    $[4] = onFilterNameSearch;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== t1 || $[7] !== t2) {
    t3 = <div className="tw-mt-4 tw-px-4 tw-col-span-full"><div className="tw-grid tw-grid-cols-1 tw-gap-y-3">{t1}{t2}</div></div>;
    $[6] = t1;
    $[7] = t2;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  return t3;
}